import { stretchBlock } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

type WrapperProps = {
  preview?: string;
  wrapperHeight?: number;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  pointer-events: none;
  ${({ wrapperHeight }) => (wrapperHeight ? `min-height: ${wrapperHeight}px` : stretchBlock)};

  ${({ preview }) =>
    preview &&
    css`
      background: url(${preview}) no-repeat center / cover;
    `};

  &:after {
    ${stretchBlock};
    z-index: 1;
    content: '';
    background: rgba(41, 42, 43, 0.5);
  }
`;
